<template>
  <!-- Floating Buttons Wrapper -->
  <transition name="fade">
    <div v-if="showFloatingButtons" class="sticky-button-wrapper">
      
      <!-- BUY NOW BUTTON -->
      <div 
        class="buy-now-btn btn btn-warning d-flex align-items-center justify-content-center"
        title="Buy Now"
        @click="redirectToBuy"
        v-if="isBuyNowShow"
      >
        <feather-icon icon="ShoppingCartIcon" class="mr-50" />
        <span class="btn-text">Buy Now</span>
      </div>

      <!-- CHAT WITH AI BUTTON -->
      <transition name="fade">
        <div 
          v-if="!user?.super_admin && user?.admin && showChatButton" 
          class="chat-ai-btn btn btn-primary shadow"
          title="Chat With AI"
          @click="toggleChatBot"
        >
          <!-- ⬆️ Larger icon -->
          <feather-icon icon="CpuIcon" class="text-white chat-icon" />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { EventBus } from "@/helpers/event-bus";
import { mapGetters } from "vuex";

export default {
  name: "FloatingButtons",
  data() {
    return {
      showChatButton: true,
      showFloatingButtons: true,
      isBuyNowShow: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "userModule/getUser",
    }),
  },
  created() {
    EventBus.$on("chatbot-opened", () => {
      this.showChatButton = false;
    });
    EventBus.$on("chatbot-closed", () => {
      this.showChatButton = true;
    });

    this.$root.$on("bv::modal::show", () => {
      this.showFloatingButtons = false;
    });
    this.$root.$on("bv::modal::hidden", () => {
      this.showFloatingButtons = true;
    });
    this.isBuyNowShow = process.env.VUE_APP_DEMO_CREDENTIALS_SHOW;
  },
  methods: {
    toggleChatBot() {
      EventBus.$emit("toggle-chatbot");
    },
    redirectToBuy() {
      window.open("https://taskfino.com/pricing", "_blank");
    },
  },
};
</script>

<style scoped>
/* ---------- Layout Container ---------- */
.sticky-button-wrapper {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: auto;
}

/* ---------- Chat Button ---------- */
.chat-ai-btn {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(115, 103, 240, 0.3);
  transition: all 0.3s ease;
}

.chat-ai-btn:hover {
  transform: scale(1.1);
}

/* ⬆️ Larger Chat Icon */
.chat-icon {
  width: 30px;
  height: 30px;
}

/* ---------- Buy Now Button ---------- */
.buy-now-btn {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(45deg, #f9a825, #ffb300);
  color: #fff !important;
  border: none;
  font-weight: 600;
  font-size: 1rem;
  padding: 10px 22px;
  border-radius: 40px;
  box-shadow: 0 6px 12px rgba(249, 168, 37, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1040;
}

.buy-now-btn:hover {
  transform: translateY(-50%) scale(1.05);
  box-shadow: 0 8px 16px rgba(249, 168, 37, 0.5);
}

.buy-now-btn .btn-text {
  font-weight: 600;
}

/* ---------- Animations ---------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ---------- Responsive Design ---------- */
@media (max-width: 768px) {
  .buy-now-btn {
    right: 10px;
    top: auto;
    bottom: 95px;
    transform: none;
    font-size: 0.9rem;
    padding: 8px 16px;
    border-radius: 30px;
  }
}

@media (max-width: 480px) {
  .buy-now-btn {
    bottom: 85px;
    font-size: 0.85rem;
    padding: 6px 14px;
  }
}
</style>
